import $ from "jquery";
// Prefer the classic global jQuery (from Serenity.Assets/jquery/jquery.js, loaded earlier as a
// plain script) if it's already there — legacy jQuery plugins (bootstrap-colorpicker,
// bootstrap-datepicker, jquery-knob, etc.) attach themselves to that instance's `.fn`, and this
// module-bundled `$` is a separate copy that would silently wipe those registrations out.
(window as any).$ = (window as any).$ ?? $;
(window as any).jQuery = (window as any).jQuery ?? $;

import { Config, ErrorHandling, TranslationConfig } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import DOMPurify from "dompurify";

Config.rootNamespaces.push('Betenbender');
TranslationConfig.getLanguageList = getLanguageList;
gridDefaults.sanitizer = (globalThis.DOMPurify = DOMPurify).sanitize;

let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (flatpickr.l10ns[culture]) {
    flatpickr.localize(flatpickr.l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);
